function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import { bool, number, array, object, func } from 'prop-types';
import { Table } from 'antd';
import React from 'react';
import ReactDOM from 'react-dom';
import InfinityTable from '../InfinityTable';
const noop = () => {};
class SumTable extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "refFooter", null);
    _defineProperty(this, "refTable", React.createRef());
    _defineProperty(this, "syncScrollFooter", target => {
      this.refFooter.scrollTo(target.scrollLeft, 0);
    });
    _defineProperty(this, "footerRender", () => {
      if (this.props.sumData) {
        const _this$props = this.props,
          sumData = _this$props.sumData,
          columns = _this$props.columns,
          scroll = _this$props.scroll;
        return React.createElement(Table, {
          columns: columns,
          dataSource: sumData,
          pagination: false,
          showHeader: false,
          scroll: scroll
        });
      }
    });
    _defineProperty(this, "handleInfinityTableScroll", e => {
      this.props.sumData && this.syncScrollFooter(e.target);
    });
  }
  componentDidMount() {
    /* eslint-disable */
    this.refFooter = ReactDOM.findDOMNode(this.refTable.current).getElementsByClassName('ant-table-footer')[0].getElementsByClassName('ant-table-body')[0];
    /* eslint-enabled */
  }
  render() {
    const dataSource = this.props.dataSource.map((data, index) => {
      data.index = index;
      return data;
    });
    return React.createElement(InfinityTable, _extends({}, this.props, {
      ref: this.refTable,
      useFixedHeader: true,
      dataSource: dataSource,
      onScroll: this.handleInfinityTableScroll,
      footer: this.footerRender,
      className: "sum-table ".concat(this.props.className ? this.props.className : '')
    }));
  }
}
SumTable.defaultProps = {
  onScroll: null,
  // 滚动事件
  onFetch: noop,
  // 滚动到低部触发Fetch方法
  sumData: null,
  // 合计行
  debug: false,
  // display console log for debug
  loading: false,
  // 是否loading状态
  pageSize: 30 // 真实DOM大小，Reality DOM row count
};
SumTable.propTypes = {
  // loading 效果
  onScroll: func,
  // 滚动事件
  onFetch: func,
  // 滚动到低部触发Fetch方法
  sumData: array.isRequired,
  // 合计行
  dataSource: array.isRequired,
  columns: array.isRequired,
  debug: bool,
  pageSize: number,
  loading: bool
};
export default SumTable;